import React from 'react';
import BindTable from './bindTable';
import { isMainAccount, isNormalAccount, isSubAccount, getMainAccountId } from '../../../consts/multiAccountConfig';

const Page = () => {
  const renderContent = () => {
    if (isMainAccount() || isNormalAccount()) {
      return <BindTable />;
    }
    if (isSubAccount()) {
      return (
        <div className="toolbars">
          <p className="toolbar-tips">{`您已将账号授权给了账号${getMainAccountId()}，已不是主账号，无法继续绑定账号，若想成为主账号，先在授权列表中取消授权，再来绑定账号，即可成为主账号。`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="onlycard">
      <div className="card">
        <div className="datarea" id="datarea">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Page;
